"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable */
var _default = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  d: "M2 12c0 5.5228 4.4771 10 10 10 5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C6.4771 2 2 6.4771 2 12zm15.6543-3.7562c-.4177-.3614-1.0492-.3158-1.4105.1019l-5.9764 6.9075-2.5603-2.5603c-.3905-.3905-1.0237-.3905-1.4142 0-.3905.3905-.3905 1.0237 0 1.4142l3.3203 3.3203c.4106.4106 1.0834.3863 1.4633-.0528l6.6797-7.7203c.3614-.4177.3158-1.0492-.1019-1.4105z",
  clipRule: "evenodd"
})), 'CheckCircleSolidIcon');
/* eslint-enable */


exports["default"] = _default;